export default {
  name: 'share-button',
  props: {
    dark: {
      type: Boolean,
      "default": false
    },
    dense: {
      type: Boolean,
      "default": false
    },
    outline: {
      type: Boolean,
      "default": false
    }
  }
};